import React, { Component, PropTypes } from 'react'
import withCdnUrl from './withCdnUrl'

export class BiColumn__map extends Component {
  render() {
    return (
      <section className="section--lgrey">
        <div className="container">
          <div className="section__body">
            <div className="row">
              <div className="column--half second">
                <div className="section__head--leftAlign market">
                  <h2>Our Markets</h2>
                  <p>Join a team in your state today! Schools and players in these states can play as a sport team or as a club in our upcoming season:</p>
                </div>
                <ul className="states">
                  <li className="sport">Alabama</li>
                  <li className="sport">Connecticut</li>
                  <li className="sport">Georgia</li>
                  <li className="sport">Kentucky</li>
                  <li className="sport">Massachusetts</li>
                  <li className="sport">Mississippi</li>
                  <li className="sport">Rhode Island</li>
                  <li className="both">Texas</li>
                  {/* club */}
                  <li>Florida</li>
                  <li>Illinois</li>
                  <li>Ohio</li>
                  <li>Pennsylvania</li>
                </ul>
              </div>
              <div className="column--half first">
                <img src={`${this.props.cdnUrl}images/map-nodes.svg`} />
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withCdnUrl(BiColumn__map)


// WEBPACK FOOTER //
// ./src/common/ui/components/biColumn__map.js